module.exports = __webpack_public_path__ + "assets/img/baitejiguan.4908753e.jpg";